// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1FlMy","colMin":"styles_colMin__38NvC"};